<nav backgroundColor="accent" color="warn" mat-align-tabs="center" mat-tab-nav-bar [tabPanel]="tabPanel"
  mat-stretch-tabs="false">
  <a (click)="activeLink = '/setup/codes/sor'" [active]="activeLink === '/setup/codes/sor'"
    [routerLink]="'/setup/codes/sor'" mat-tab-link>SOR Codes</a>

  <a (click)="activeLink = '/setup/codes/priority'" [active]="activeLink === '/setup/codes/priority'"
    [routerLink]="'/setup/codes/priority'" mat-tab-link>Priority</a>
  <a (click)="activeLink = '/setup/codes/completion'" [active]="activeLink === '/setup/codes/completion'"
    [routerLink]="'/setup/codes/completion'" mat-tab-link>Completion</a>
  <a (click)="activeLink = '/setup/codes/availability'" [active]="activeLink === '/setup/codes/availability'"
    [routerLink]="'/setup/codes/availability'" mat-tab-link>Availability</a>
  <a (click)="activeLink = '/setup/codes/bookingReasons'" [active]="activeLink === '/setup/codes/bookingReasons'"
    [routerLink]="'/setup/codes/bookingReasons'" mat-tab-link>Booking Reasons</a>
  @if (enableTimesheet) {
  <a (click)="activeLink = '/setup/codes/timesheetCodes'" [active]="activeLink === '/setup/codes/timesheetCodes'"
    [routerLink]="'/setup/codes/timesheetCodes'" mat-tab-link>Timesheet Codes</a>
  }
  <a (click)="activeLink = '/setup/codes/sorOverrides'" [active]="activeLink === '/setup/codes/sorOverrides'"
    [routerLink]="'/setup/codes/sorOverrides'" mat-tab-link>SOR Overrides</a>
</nav>
<mat-tab-nav-panel #tabPanel>
  <router-outlet></router-outlet>
</mat-tab-nav-panel>